import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name: string;
  image?: string;
}

type Language = 'en' | 'es' | 'zh' | 'fr' | 'de';
type UiTheme = 'skeuomorphism' | 'neubrutalism';

interface AppState {
  user: User | null;
  darkMode: boolean;
  hasSeenOnboarding: boolean;
  language: Language;
  uiTheme: UiTheme;
  setUser: (user: User | null) => void;
  setDarkMode: (value: boolean) => void;
  setHasSeenOnboarding: (value: boolean) => void;
  setLanguage: (value: Language) => void;
  setUiTheme: (value: UiTheme) => void;
  reset: () => void;
}

export const useStore = create<AppState>()(
  persist(
    (set) => ({
      user: null,
      darkMode: false,
      hasSeenOnboarding: false,
      language: 'en',
      uiTheme: 'skeuomorphism',
      setUser: (user) => set({ user }),
      setDarkMode: (value) => set({ darkMode: value }),
      setHasSeenOnboarding: (value) => set({ hasSeenOnboarding: value }),
      setLanguage: (value) => set({ language: value }),
      setUiTheme: (value) => set({ uiTheme: value }),
      reset: () => set({ 
        user: null, 
        hasSeenOnboarding: false 
      }),
    }),
    {
      name: 'proof-of-learning-store',
      partialize: (state) => ({ 
        user: state.user, 
        darkMode: state.darkMode, 
        hasSeenOnboarding: state.hasSeenOnboarding,
        language: state.language,
        uiTheme: state.uiTheme 
      }),
    }
  )
);
